exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".userdata-wrap{background:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/appBackend/components/page/userdata/userdata/userdata.scss
// module id = 562
// module chunks = 2